import React from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import EditablePanelComponent from './editablePanelComponent';
import { getChangePasswordURL } from '../../helpers/auth';

@connect(({ session, localize, profile: { profileData } }) => ({
  translate: getTranslate(localize),
  session
}))
export default class PersonalInfo extends EditablePanelComponent {
  render() {
    return (
      <a href = {getChangePasswordURL()}>
        {this.props.translate('profile.changePassword')}
      </a>
    )
  }
}
